/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export const LOAD_HOME_SCREEN_DATA = 'LOAD_HOME_SCREEN_DATA';
export const LOAD_HOME_SCREEN_MORE_CAROUSELS = 'LOAD_HOME_SCREEN_MORE_CAROUSELS';
export const LOAD_HOME_SCREEN_MORE_FEED_ITEMS = 'LOAD_HOME_SCREEN_MORE_FEED_ITEMS';
export const SET_HOME_SCREEN_FOCUS = 'SET_HOME_SCREEN_FOCUS';
export const SET_HOME_SCREEN_PREVIEW = 'SET_HOME_SCREEN_PREVIEW';
export const SET_HOME_SCREEN_ERROR = 'SET_HOME_SCREEN_ERROR';
export const SET_HOME_SCREEN_LOADING = 'SET_HOME_SCREEN_LOADING';
export const SET_HOME_SCREEN_NAV_FOCUS = 'SET_HOME_SCREEN_NAV_FOCUS';
export const SET_HOME_SCREEN_GHOST = 'SET_HOME_SCREEN_GHOST';
export const SET_HOME_SCREEN_VERTICAL_SCROLL = 'SET_HOME_SCREEN_VERTICAL_SCROLL';
export const SET_HOME_SCREEN_NAV_ITEMS = 'SET_HOME_SCREEN_NAV_ITEMS';
export const RESET_HOME_SCREEN = 'RESET_HOME_SCREEN';
export const REFRESH_HOME_SCREEN = 'REFRESH_HOME_SCREEN';
export const SET_HOME_SCREEN_LOADING_MORE_CAROUSELS = 'SET_HOME_SCREEN_LOADING_MORE_CAROUSELS';
